export default "__VITE_ASSET__FyUl3Xq2__"